import React from 'react';
import { motion } from 'framer-motion';
import { SparklesIcon, WrenchIcon, AnchorIcon } from 'lucide-react';
const fadeInUp = {
  initial: {
    opacity: 0,
    y: 30
  },
  whileInView: {
    opacity: 1,
    y: 0
  },
  viewport: {
    once: true,
    margin: '-100px'
  },
  transition: {
    duration: 0.6
  }
};
const phases = [{
  number: '1',
  days: 'Días 1–7',
  title: 'DESINFLAMAR',
  icon: SparklesIcon,
  description: 'Aquí bajamos el "ruido". Menos mezcla, más claridad. Platos simples y estables para que tu cuerpo deje de reaccionar como alarma.',
  color: '#A7C4A0'
}, {
  number: '2',
  days: 'Días 8–14',
  title: 'REPARAR',
  icon: WrenchIcon,
  description: 'Aquí arreglamos el patrón que te hace reincidir: tránsito lento, fibra mal manejada, agua mal distribuida, estrés que se mete al intestino.',
  color: '#C75B39'
}, {
  number: '3',
  days: 'Días 15–21',
  title: 'ESTABILIZAR',
  icon: AnchorIcon,
  description: 'Aquí se vuelve vida real. Aprendes a comer corrientazo, a tener fin de semana, a darte gusto… y aun así volver a tu centro sin drama.',
  color: '#1B4332'
}];
export function TriadaSection() {
  return <section className="w-full bg-[#FAF3E0] py-20 md:py-28 px-4" data-id="element-147">
      <div className="max-w-5xl mx-auto" data-id="element-148">
        <motion.div {...fadeInUp} className="text-center mb-16" data-id="element-149">
          <p className="text-[#C75B39] font-medium tracking-wide uppercase mb-4" data-id="element-150">
            El Método
          </p>
          <h2 className="text-3xl md:text-4xl lg:text-5xl font-bold text-[#1B4332] mb-6" data-id="element-151">
            La Triada 21D
          </h2>
          <p className="text-[#1B4332]/70 text-lg md:text-xl max-w-2xl mx-auto" data-id="element-152">
            Desinflamar → Reparar → Estabilizar
          </p>
        </motion.div>

        <div className="grid md:grid-cols-3 gap-8" data-id="element-153">
          {phases.map((phase, index) => <motion.div key={phase.number} initial={{
          opacity: 0,
          y: 40
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          duration: 0.6,
          delay: 0.15 * index
        }} className="bg-white rounded-3xl p-8 shadow-lg hover:shadow-xl transition-shadow duration-300" data-id="element-154">
              <div className="w-16 h-16 rounded-2xl flex items-center justify-center mb-6" style={{
            backgroundColor: `${phase.color}20`
          }} data-id="element-155">
                <phase.icon className="w-8 h-8" style={{
              color: phase.color
            }} data-id="element-156" />
              </div>

              <p className="text-sm font-medium text-[#1B4332]/50 mb-2" data-id="element-157">
                Fase {phase.number} • {phase.days}
              </p>

              <h3 className="text-2xl font-bold mb-4" style={{
            color: phase.color
          }} data-id="element-158">
                {phase.title}
              </h3>

              <p className="text-[#1B4332]/70 leading-relaxed" data-id="element-159">
                {phase.description}
              </p>
            </motion.div>)}
        </div>

        <motion.div {...fadeInUp} transition={{
        duration: 0.6,
        delay: 0.5
      }} className="text-center mt-16" data-id="element-160">
          <a href="#precio" className="inline-block bg-[#C75B39] text-white text-lg font-semibold px-10 py-4 rounded-full 
                       hover:scale-105 transition-transform duration-200 shadow-lg hover:shadow-xl" data-id="element-161">
            Empezar el protocolo →
          </a>
        </motion.div>
      </div>
    </section>;
}